export const env: { [s: string]: string | null } = {
  npm_package_version: '5.1.501',
};
